<template>
    <div id="reports">
        <v-overlay absolute="" opacity="0.2" :value="loader">
            <v-progress-circular :color="appColor" indeterminate size="32"></v-progress-circular>
        </v-overlay>
        <v-snackbar v-model="snackbar.status" top :color="snackbar.color" :timeout="snackbar.timeout">
            <v-icon class="mr-1">{{ snackbar.icon }}</v-icon> {{ snackbar.message }}
        </v-snackbar>
        <reports-toolbar></reports-toolbar>
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <reports-menu :currQuery="currQuery" :loadQueryItems="loadQueryItems" :runQueryID="runQueryID"
                        :statusSave="statusSave" :statusUpdate="statusUpdate" @addQuery="addQuery"
                        @deleteQuery="deleteQuery" @downloadQuery="downloadQuery" @loadQuery="loadQuery"
                        @resetQuery="resetQuery" @saveQuery="saveQuery" @setQuery="setQuery"
                        @setStatusSave="setStatusSave" @setStatusUpdate="setStatusUpdate" @updateQuery="updateQuery">
                    </reports-menu>
                </v-col>
                <v-col cols="12">
                    <v-form ref="queryDatabaseForm" v-model="valid" lazy-validation>
                        <reports-query ref="reportsQuery" :data="data" :currQuery="currQuery" :legacyColumns="legacyColumns"
                            :modernColumns="modernColumns" :valid="valid" @addColumn="addColumn"
                            @removeColumn="removeColumn" @removeQuery="removeQuery" @runQuery="runQuery">
                        </reports-query>
                    </v-form>
                </v-col>
                <v-col cols="12">
                    <reports-data ref="queryData" :headers="headers" :rows="rows"></reports-data>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import ReportsData from '../../components/Admin/Reports/Data';
import ReportsMenu from '../../components/Admin/Reports/Menu';
import ReportsQuery from '../../components/Admin/Reports/Query';
import ReportsToolbar from '../../components/Admin/Reports/Toolbar';

export default {
    name: 'reports',
    components: {
        ReportsData,
        ReportsMenu,
        ReportsQuery,
        ReportsToolbar
    },
    data() {
        return {
            currQuery: {
                databaseType: '',
                id: '',
                description: '',
                name: '',
                queries: []
            },
            data: [],
            headers: [],
            legacyColumns: [],
            loadQueryItems: [],
            loader: true,
            modernColumns: [],
            permission: {},
            snackbar: {
                color: 'success',
                icon: '',
                message: '',
                status: false,
                timeout: 5000
            },
            statusSave: false,
            statusUpdate: false,
            rows: [],
            runQueryID: '',
            valid: true
        }
    },
    methods: {
        addColumn(query) {
            query.columns.push({
                compare: '',
                field: '',
                label: '',
                show: '1',
                term: '',
                type: ''
            })
        },
        addQuery() {
            this.currQuery.queries.push({
                columns: [{
                    compare: '',
                    field: '',
                    label: '',
                    show: '1',
                    term: '',
                    type: ''
                }]
            });
        },
        deleteQuery() {
            const that = this;
            const formData = new FormData();
            let api = `https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?deleteQuery`;

            // Parse array into string
            formData.append('data', JSON.stringify({
                id: this.currQuery.id
            }));
            formData.append('mode', 'deleteQuery');

            // Post request
            fetch(api, {
                    method: 'POST',
                    body: formData
                })
                .then(function (response) {
                    // Return JSON response
                    return response.json();
                })
                .then(function (json) {
                    // Success result
                    if (json.result.match(/OK/i)) {
                        that.resetQuery();
                        that.setNotification('#1dc9b7', 'mdi-database-check', `The database query configuration was successfully deleted.`, true);
                    } else if (json.message.match(/UNAUTHORIZED/i)) {
                        that.setNotification('#f64e60', 'mdi-alert-circle', `You are not authorized to perform this action. Please refresh your application.`, true);
                    } else {
                        that.setNotification('#ffb822', 'mdi-database-alert', `The database query configuration could not be deleted. ${json.message}.`, true);
                    }
                })
                .catch(function () {
                    that.setNotification('#f64e60', 'mdi-alert-circle', `An error occurred. Please contact your system administrator.`, true);
                });
        },
        downloadQuery() {
            if (!this.runQueryID) {
                this.setNotification('#5578eb', 'mdi-database-alert', `Please run a valid database configuration.`, true);
            } else {
                let data = {
                    id: this.runQueryID
                };
                let object = JSON.stringify(data);
                let api = encodeURI(`https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?exportQuery&data=${object}`);
                window.open(api);
            }
        },
        getReportsData() {
            const that = this;
            let api =
                `https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?getReportsConfig`;

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return response
                    return response.json();
                })
                .then(function (json) {
                    // Error handling
                    if (json.result.match(/OK/i)) {
                        that.data = json.data;
                        that.legacyColumns = json["data.legacy"];
                        that.modernColumns = json["data.modern"];
                    } else if (json.message.match(/UNAUTHORIZED/i)) {
                        that.setNotification('#f64e60', 'mdi-alert-circle', `You are not authorized to view this resource. Please refresh your application.`, true);
                    } else if (!json.result.match(/OK/i)) {
                        that.setNotification('#ffb822', 'mdi-alert-circle', `Reports data could not be retrieved. Please contact your system administrator.`, true);
                    }

                    that.setLoader(false);
                })
                .catch(function () {
                    that.setLoader(false);
                })
        },
        loadQuery() {
            const that = this;
            let api = `https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?getQuery`;

            // Post request
            fetch(api)
                .then(function (response) {
                    // Return JSON response
                    return response.json();
                })
                .then(function (json) {
                    // Success result
                    if (json.result.match(/OK/i)) {
                        that.loadQueryItems = json.data;
                    } else if (json.message.match(/UNAUTHORIZED/i)) {
                        that.setNotification('#f64e60', 'mdi-alert-circle', `You are not authorized to perform this action. Please refresh your application.`, true);
                    } else {
                        that.setNotification('#ffb822', 'mdi-database-alert', `The saved database query configurations could not be loaded. ${json.message}.`, true);
                    }
                })
                .catch(function () {
                    that.setNotification('#f64e60', 'mdi-alert-circle', `An error occurred. Please contact your system administrator.`, true);
                });
        },
        refreshData() {
            this.getReportsData();
        },
        removeColumn(query, index) {
            query.columns.splice(index, 1);
        },
        removeQuery(index) {
            this.currQuery.queries.splice(index, 1);
        },
        resetQuery() {
            this.getReportsData();
            this.headers = [];
            this.currQuery = {
                databaseType: '',
                id: '',
                description: '',
                name: '',
                queries: []
            };
            this.rows = [];
            this.runQueryID = '';
            this.setNotification('#1dc9b7', 'mdi-database-refresh', `The database query configuration has been reset.`, true)
        },
        runQuery() {
            let valid = true;

            // Check for queries
            valid = this.currQuery.queries.length == 0 ? false : valid;

            // Validate queries
            for (let i = 0; i < this.currQuery.queries.length; i++) {
                if (this.currQuery.queries[i].columns.length == 0) {
                    valid = false;
                    break;
                }
            }

            if (!valid) {
                this.setNotification('#5578eb', 'mdi-database-alert', `Please provide a valid database query configuration.`, true);
            } else {
                if (this.$refs.queryDatabaseForm.validate()) {
                    const that = this;
                    const formData = new FormData();
                    let api = `https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?executeQuery&returnType=vue`;

                    // Parse array into string
                    formData.append('data', JSON.stringify({
                        databaseType: this.currQuery.databaseType,
                        queries: this.currQuery.queries
                    }));
                    formData.append('mode', 'executeQuery');
                    formData.append('returnType', 'vue');

                    // Set table loader
                    this.$refs.queryData.setTableLoader(true);
                    this.$refs.reportsQuery.setBtnLoader(true);

                    // Post request
                    fetch(api, {
                            method: 'POST',
                            body: formData
                        })
                        .then(function (response) {
                            // Return JSON response
                            return response.json();
                        })
                        .then(function (json) {
                            // Success result
                            if (json.result.match(/OK/i)) {
                                that.setNotification('#1dc9b7', 'mdi-database-search', `The database query was successful.`, true);
                                that.headers = json.data && json.data.headers ? json.data.headers : [];
                                that.rows = json.data && json.data.rows ? json.data.rows : [];
                                that.runQueryID = json.id && json.id ? json.id : '';
                            } else if (json.message.match(/UNAUTHORIZED/i)) {
                                that.setNotification('#f64e60', 'mdi-alert-circle', `You are not authorized to perform this action. Please refresh your application.`, true);
                            } else {
                                that.setNotification('#ffb822', 'mdi-database-alert', `The database query was unsuccessful. ${json.message}.`, true);
                            }

                            // Set table loader
                            that.$refs.queryData.setTableLoader(false);
                            that.$refs.reportsQuery.setBtnLoader(false);
                        })
                        .catch(function () {
                            // Set table loader
                            that.$refs.queryData.setTableLoader(false);
                            that.$refs.reportsQuery.setBtnLoader(false);
                            that.setNotification('#f64e60', 'mdi-alert-circle', `An error occurred. Please contact your system administrator.`, true);
                        });
                }
            }
        },
        saveQuery(query) {
            let valid = true;

            // Check for queries
            valid = this.currQuery.queries.length == 0 ? false : valid;

            // Validate queries
            for (let i = 0; i < this.currQuery.queries.length; i++) {
                if (this.currQuery.queries[i].columns.length == 0) {
                    valid = false;
                    break;
                }
            }

            if (!valid) {
                this.setNotification('#5578eb', 'mdi-database-alert', `Please provide a valid database query configuration.`, true)
            } else {
                const that = this;
                const formData = new FormData();
                let api = `https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?setQuery`;

                // Parse array into string
                formData.append('data', JSON.stringify({
                    databaseType: this.currQuery.databaseType,
                    description: query.description,
                    name: query.name,
                    queries: this.currQuery.queries
                }));
                formData.append('mode', 'setQuery');

                // Set status save
                this.setStatusSave(true);

                // Post request
                fetch(api, {
                        method: 'POST',
                        body: formData
                    })
                    .then(function (response) {
                        // Return JSON response
                        return response.json();
                    })
                    .then(function (json) {
                        // Success result
                        if (json.result.match(/OK/i)) {
                            that.setNotification('#1dc9b7', 'mdi-database-check', `The database query configuration was successfully saved.`, true);
                            that.currQuery.description = query.description;
                            that.currQuery.id = json.id;
                            that.currQuery.name = query.name;
                        } else if (json.message.match(/UNAUTHORIZED/i)) {
                            that.setNotification('#f64e60', 'mdi-alert-circle', `You are not authorized to perform this action. Please refresh your application.`, true);
                        } else {
                            that.setNotification('#ffb822', 'mdi-database-alert', `The database query configuration could not be saved. ${json.message}.`, true);
                        }
                    })
                    .catch(function () {
                        that.setNotification('#f64e60', 'mdi-alert-circle', `An error occurred. Please contact your system administrator.`, true);
                    });
            }
        },
        setLoader(bool) {
            this.loader = bool;
        },
        setQuery(query) {
            this.currQuery = query;
            this.headers = [];
            this.rows = [];
            this.runQueryID = '';
            this.$refs.reportsQuery.setColumns();
            this.setNotification('#1dc9b7', 'mdi-database-check', `The database query configuration has been loaded.`, true);
        },
        setNotification(color, icon, message, status) {
            // Reset snackbar
            this.snackbar.status = false;

            // Set snackbar fields
            this.snackbar.color = color;
            this.snackbar.icon = icon;
            this.snackbar.message = message;
            this.snackbar.status = status;
        },
        setStatusSave(bool) {
            this.statusSave = bool;
        },
        setStatusUpdate(bool) {
            this.statusUpdate = bool;
        },
        updateQuery(query) {
            let valid = true;

            // Check for queries
            valid = this.currQuery.queries.length == 0 ? false : valid;

            // Validate queries
            for (let i = 0; i < this.currQuery.queries.length; i++) {
                if (this.currQuery.queries[i].columns.length == 0) {
                    valid = false;
                    break;
                }
            }

            if (!valid) {
                this.setNotification('#5578eb', 'mdi-database-alert', `Please provide a valid database query configuration.`, true)
            } else {
                const that = this;
                const formData = new FormData();
                let api = `https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?setQuery`;

                // Parse array into string
                formData.append('data', JSON.stringify({
                    databaseType: this.currQuery.databaseType,
                    description: query.description,
                    id: query.id,
                    name: query.name,
                    queries: this.currQuery.queries
                }));
                formData.append('mode', 'setQuery');

                // Set status save
                this.setStatusUpdate(true);

                // Post request
                fetch(api, {
                        method: 'POST',
                        body: formData
                    })
                    .then(function (response) {
                        // Return JSON response
                        return response.json();
                    })
                    .then(function (json) {
                        // Success result
                        if (json.result.match(/OK/i)) {
                            that.setNotification('#1dc9b7', 'mdi-database-check', `The database query configuration was successfully updated.`, true);
                            that.currQuery.description = query.description;
                            that.currQuery.id = json.id;
                            that.currQuery.name = query.name;
                        } else if (json.message.match(/UNAUTHORIZED/i)) {
                            that.setNotification('#f64e60', 'mdi-alert-circle', `You are not authorized to perform this action. Please refresh your application.`, true);
                        } else {
                            that.setNotification('#ffb822', 'mdi-database-alert', `The database query configuration could not be updated. ${json.message}.`, true);
                        }
                    })
                    .catch(function () {
                        that.setNotification('#f64e60', 'mdi-alert-circle', `An error occurred. Please contact your system administrator.`, true);
                    });
            }
        }
    },
    computed: {
        appColor() {
            return '#191b2a';
        }
    },
    created() {
        this.getReportsData();
    }
}
</script>